import enviro from 'enviro';
import Raven from 'raven-js';

export const getHostAppName = (): string | null => {
  try {
    // @ts-ignore - No bender type in the hubspot window object
    return window.top?.hubspot?.bender?.currentProject ?? null;
  } catch (e) {
    if (enviro.deployed()) {
      Raven.captureException(
        new Error('Failed to get host app name from bender', { cause: e }),
        {
          extra: { e },
        }
      );
    }

    // Cross-origin access fails locally; return fallback
    return null;
  }
};
